/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Auth'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import { eventBus } from '../../../main';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> User -------------------------------------------
    auth_userLoggedIn: false,
    auth_user: null,

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: Auth Calls
    ***************************************************************************/
    /***************************************************************************
    * get_authorizationUserdata()
    *
    * Desc: Return ... Catch up User Date from Ls.
    * Note:
    *
    */
    get_authorizationUserdata: state => {

        let localStorageUser = null,
            localStorageUserData = JSON.parse(localStorage.getItem('sdr__authorizationUserdata'));


        // >>> User in localStorage? ----------------------
        if (localStorageUserData !== null) {
            localStorageUser = JSON.parse(localStorageUserData.value);
        }


        return localStorageUser;

    }, // eo function get_authorizationUserdata()


    /***************************************************************************
    * get_authorizationHeader()
    *
    * Desc: Return ... Catch up Auth Header from Ls.
    * Note:
    *
    */
    get_authorizationHeader: state => {

        let localStorageHeader = null,
            localStorageHeaderData = JSON.parse(localStorage.getItem('sdr__authorizationHeader'));


        // >>> Header in localStorage? --------------------
        if (localStorageHeaderData !== null) {
            localStorageHeader = JSON.parse(localStorageHeaderData.value);
        }


        return localStorageHeader;

    }, // eo function get_authorizationUserdata()




    /***************************************************************************
    * Getters: Flags & Co
    ***************************************************************************/
    /***************************************************************************
    * get_Flag_Auth_UserLoggedIn()
    *
    * Desc: Return ... Flag 'is User logged in?'
    * Note:
    *
    */
    get_Flag_Auth_UserLoggedIn: state => {

        return state.auth_userLoggedIn;

    }, // eo function get_Flag_Auth_UserLoggedIn()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: Auth Calls
    ***************************************************************************/
    /***************************************************************************
    * mut_call_auth_login()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_auth_login: (state, payload) => {

        Vue['ls'].set('authorizationHeader', JSON.stringify(payload.authorizationHeader), 60 * 60 * 1000);
        Vue['ls'].set('authorizationUserdata', JSON.stringify(payload.payload), 60 * 60 * 1000);

        state.auth_userLoggedIn = true; // kind of useless here
        state.auth_userLoggedIn = payload.payload;


        // reload page
        setTimeout(function () {
            location.reload();
        }, 700);

    }, // eo function mut_call_auth_login()




    /***************************************************************************
    * Mutations: Flags & Co
    ***************************************************************************/
    /***************************************************************************
    * mut_auth_logout()
    *
    * Desc:
    * Note:
    *
    */
    mut_auth_logout: (state, payload) => {

        Vue['ls'].remove('authorizationHeader');
        Vue['ls'].remove('authorizationUserdata');

        state.auth_userLoggedIn = false; // kind of useless here
        state.auth_userLoggedIn = null;


        // reload page
        setTimeout(function () {
            location.reload();
        }, 700);

    }, // eo function mut_auth_logout()


    /***************************************************************************
    * mut_set_Flag_Auth_UserLoggedIn()
    *
    * Desc:
    * Note:
    *
    */
    mut_set_Flag_Auth_UserLoggedIn: (state, payload) => {

        state.auth_userLoggedIn = payload;

    }, // eo function mut_set_Flag_Auth_UserLoggedIn()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: Auth Calls
    ***************************************************************************/
    /***************************************************************************
    * Call::'/booking/profile/login';
    *
    * Desc:
    * Note:
    * Note: Translate in Vuex here ..  via context.rootGetters.
    * Note: A 401 Error gets send as 200 with Air41-Error: [105120]
    */
    actn_call_auth_login: (context, payload) => {

        let hdrs = '',
            trsnltd = '',
            authorizationHeader = '';


        // >>> Set Auth Header ----------------------------
        if ("authorizationHeader" in payload) {
            authorizationHeader = payload.authorizationHeader;
        }
        if (!("authorizationHeader" in payload)) {
            authorizationHeader = window.btoa(payload.email + ":" + payload.password);
        }


        // >>> Send Ajax Request --------------------------
        axios.get("/booking/profile/login", {
            withCredentials: true,
            headers: {
                "Authorization": "Basic " + authorizationHeader
            }})
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: context.rootGetters.getCurrentLocale === 'de' ? 'Willkommen zurück.' : 'Welcome back.'
                        });
                        context.commit('mut_call_auth_login', { payload: response.data, authorizationHeader: authorizationHeader });
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        context.commit('actn_auth_logout');
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
                context.commit('actn_auth_logout');
            });

    }, // eo function actn_call_auth_login()


    /***************************************************************************
    * Call::'/rest/booking/profile/create';
    *
    * Desc: Call: Create an user.
    * Note:
    */
    actn_call_auth_create: (context, payload) => {

        let hdrs = '',
            trsnltd = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/booking/profile/create', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('call_auth_userCreate_success'); // works
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_auth_create()


    /***************************************************************************
    * Call::'/rest/booking/profile/forgot';
    *
    * Desc:
    * Note:
    *
    */
    actn_call_auth_passwordReset: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/booking/profile/forgot', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('call_auth_passwordReset_success'); // works

                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_auth_passwordReset()




    /***************************************************************************
    * Actions: Flags & Co
    ***************************************************************************/
    /***************************************************************************
    * actn_set_Flag_Auth_UserLoggedIn()
    *
    * Desc: ACTION: Set Flag 'User is logged in?'.
    * Note: CONTROL FLAG
    *
    */
    actn_set_Flag_Auth_UserLoggedIn: (context, payload) => {

        context.commit('mut_set_Flag_Auth_UserLoggedIn', payload);

    }, // eo function actn_set_Flag_Auth_UserLoggedIn()


    /***************************************************************************
    * actn_auth_logout()
    *
    * Desc:
    * Note:
    *
    */
    actn_auth_logout: (context, payload) => {

        context.commit('mut_auth_logout');

    }, // eo function actn_auth_logout()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/auth.js